/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * Used for RX feature, mainly for seamless window
 * beta to reduce the refactor effort.
 */

export namespace Port {
   export enum ChannelName {
      Settings = "Settings",
      Session = "Session",
      VDPService = "VDPService",
      RTAV = "RTAV",
      CDR = "CDR",
      UrlRedirection = "UrlRedirection",
      USB = "UsbRedirection"
   }

   export enum MsgType {
      RTAV = "RTAV",
      Session = "Session",
      CDR = "CDR",
      VDPService = "VDPService",
      Settings = "Settings",
      UrlRedirection = "UrlRedirection"
   }

   export enum RTAVMsg {
      ChannelOpen = "ChannelOpen",
      ChannelClose = "ChannelClose",
      ChannelError = "ChannelError",
      ChannelMessage = "ChannelMessage",
      ChannelResponse = "ChannelResponse",
      DeviceStatus = "DeviceStatus"
   }

   export enum SessionMsg {
      onConnecting = "onConnecting",
      onConnected = "onConnected",
      onDisconnecting = "onDisconnecting",
      onDisconnected = "onDisconnected",
      onClosed = "onClosed",
      onReconnectToken = "onReconnectToken", //for network recovery and broker session reuse
      onSessionActive = "onSessionActive",
      requestSessionDisconnect = "requestSessionDisconnect",
      sessionMessage = "sessionMessage",
      sessionMessageHandled = "sessionMessageHandled",
      desktopSessionLogOut = "desktopSessionLogOut",
      desktopSessionDisconnect = "desktopSessionDisconnect",
      restoreApplicationSession = "restoreApplicationSession",
      restoreApp = "restoreApp",
      requestWindowClose = "requestWindowClose",
      onWindowClosed = "onWindowClosed",
      onRecoveryReq = "onRecoveryReq",
      onRecoveryRes = "onRecoveryRes"
   }

   export enum CDRMsg {
      requestFolderInfos = "requestFolderInfos", //session to parent
      AccessibleFolderInfos = "AccessibleFolderInfos", //parent to session
      updateFolderInfos = "updateFolderInfos",
      newFolderFromFA = "newFolderFromFA",
      getLatestFileInfo = "getLatestFileInfo", //session to parent
      cdrReady = "cdrReady" //parent to session
   }

   export enum USBMsg {
      desktopName = "desktopName",
      deviceOnInsert = "deviceOnInsert",
      DeviceChanged = "deviceChanged",
      getRedirectedDevices = "getRedirectedDevices",
      isDeviceRedirected = "isDeviceRedirected",
      onUsbConnected = "onUsbConnected",
      policyDeviceSync = "policyDeviceSync"
   }

   export enum SettingMsg {
      Resolution = "Resolution", //{width:int,height:int}
      enableHighResolution = "enableHighResolution", //boolean
      enableWebRTCRedirection = "enableWebRTCRedirection", //boolean
      enableScreenSharing = "enableScreenSharing", //boolean
      enableWindowsKey = "enableWindowsKey", //boolean
      enableWindowsDeleteKey = "enableWindowsDeleteKey",
      enableGeolocationSharing = "enableGeolocationSharing", //boolean
      donotShowGeolocationDialog = "donotShowGeolocationDialog", //boolean
      enableMediaStreamPermission = "enableMediaStreamPermission", //boolean
      donotShowMediaStreamPermissionDialog = "donotShowMediaStreamPermissionDialog", //boolean
      syncBackSettings = "syncBackSettings", //Array<SettingItem>
      enableBCR = "enableBCR",
      checkAnyInMultimon = "checkAnyInMultimon",
      enterMultimon = "enterMultimon",
      exitMultimon = "exitMultimon",
      selectedMonitors = "selectedMonitors",
      desktopFocused = "desktopFocused",
      multimonAlive = "multimonAlive",
      disableNetworkStateDisplay = "disableNetworkStateDisplay"
   }

   export enum UrlRedirectionMsg {
      RedirectToAgent = "RedirectToAgent"
   }
}
